module.exports = __webpack_public_path__ + "img/laboratorio2_3-4_512.a4ea9297.jpg";